import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import UsersTab from './System/UsersTab';
import SubscriptionsTab from './System/SubscriptionsTab';
import DepositsTab from './System/DepositsTab';
import PaymentsTab from './System/PaymentsTab';
import SummaryCards from './System/SummaryCards';

const TABS = [
  { key: 'users', label: 'Users', Component: UsersTab },
  { key: 'subscriptions', label: 'Subscriptions', Component: SubscriptionsTab },
  { key: 'deposits', label: 'Deposits', Component: DepositsTab },
  { key: 'payments', label: 'Payments', Component: PaymentsTab },
];

export default function SystemPage() {
  const [activeTab, setActiveTab] = useState('users');
  const ActiveComponent = TABS.find((tab) => tab.key === activeTab)?.Component ?? UsersTab;

  return (
    <section className="space-y-3">
      <Toaster position="top-right" toastOptions={{ duration: 2500 }} />

      <SummaryCards activeTab={activeTab} onSelectTab={setActiveTab} />

      {/* <div className="flex gap-2 rounded-xl border border-cyan-100 bg-white p-2">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={[
              'rounded-lg px-4 py-2 text-sm font-medium transition-colors',
              activeTab === tab.key
                ? 'bg-cyan-50 text-cyan-800'
                : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900',
            ].join(' ')}
          >
            {tab.label}
          </button>
        ))}
      </div> */}

      <ActiveComponent />
    </section>
  );
}
